import { render, staticRenderFns } from "./ServiceProviderDamageAssessorApplicationsCard.vue?vue&type=template&id=0939bdf3"
import script from "./ServiceProviderDamageAssessorApplicationsCard.vue?vue&type=script&lang=js"
export * from "./ServiceProviderDamageAssessorApplicationsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports